import React from 'react'
import PropTypes from 'prop-types'

import { formatDate } from '../../utils/FormatDate'
import ButtonVariantEnum from '../../enums/ButtonVariant'

import {
  CardInformationDesktop,
  CardInformationMobile,
  StyledBottomContainer,
  StyledButtonDownload,
  StyledCategories,
  StyledCategory,
  StyledDate,
  StyledDateContainer,
  StyledLeftContainer,
  StyledParagraph,
  StyledReadMore,
  StyledSearchCard,
  StyledSeparator,
  StyledTitle,
  StyledTitleLink,
} from './SearchCard.styled'
import { HeadingSizeEnum } from '../Heading/Heading'
import ChipVariantEnum from '../../enums/ChipVariant'
import { getSizeFromDocument } from '../../utils/GetSizeFromDocument.js'
import RoutingEnum from '../../routes/appRoutes'
import useMediaQuery from '../../hooks/useMediaQuery'
import { deviceMax } from '../../theme/breakpoints'

const DOCUMENT = 'Document'
const READ_MORE = 'Read More'
const INVESTORS_CTA = 'investors_cta'
const TO_BE_DEFINED = 'To Be Defined'

const SearchCard = (props) => {
  const {
    categories,
    date,
    document,
    text,
    title,
    to,
    isInvestor = false,
  } = props

  const dateFormated = date && formatDate(date)

  const isMobile = useMediaQuery(deviceMax.mobileL)

  const categoriesList = document ? (
    <StyledCategory label={DOCUMENT} variant={ChipVariantEnum.secondary} />
  ) : (
    categories?.map((category, index) => {
      if(!category?.fields && !category.name) return null
      const { name, title: storyName } = category?.fields || category.name
      const { id } = category?.sys
      if (name === TO_BE_DEFINED || storyName === TO_BE_DEFINED) return null
      if (index > 1) return null
      return (
        <StyledCategory
          key={title + id}
          label={name || storyName}
          variant={ChipVariantEnum.secondary}
        />
      )
    })
  )

  const cardInformation = (
    <StyledLeftContainer>
      {(dateFormated || categoriesList) && (
        <>
          {categoriesList && !isInvestor && (
            <StyledCategories>
              {!isMobile && <StyledSeparator />}
              {categoriesList}
            </StyledCategories>
          )}

          {dateFormated && !document && (
            <StyledDateContainer>
              {(isMobile || isInvestor) && <StyledSeparator />}
              <StyledDate>{dateFormated}</StyledDate>
            </StyledDateContainer>
          )}
        </>
      )}
    </StyledLeftContainer>
  )

  return (
    <StyledSearchCard $isInvestor={isInvestor}>
      <CardInformationMobile>{cardInformation}</CardInformationMobile>
      {isInvestor ? (
        <StyledTitleLink to={to && RoutingEnum.news + to}>
          {title}
        </StyledTitleLink>
      ) : (
        <StyledTitle label={title} size={HeadingSizeEnum.h2} />
      )}
      {text && <StyledParagraph>{text}</StyledParagraph>}
      <StyledBottomContainer>
        <CardInformationDesktop>{cardInformation}</CardInformationDesktop>
        {!document && !isInvestor && (
          <StyledReadMore
            className={INVESTORS_CTA}
            label={to && READ_MORE}
            to={to && to}
            variant={ButtonVariantEnum.secondary}
          />
        )}
        {document && (
          <StyledButtonDownload
            $isInvestor={isInvestor}
            name={title}
            description={getSizeFromDocument(document)}
            document={document}
          />
        )}
      </StyledBottomContainer>
    </StyledSearchCard>
  )
}

SearchCard.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.object),
  date: PropTypes.string,
  document: PropTypes.object,
  text: PropTypes.string,
  title: PropTypes.string.isRequired,
  to: PropTypes.string,
}

export default SearchCard
